<template>
  <div>
    <el-row class="bg-color-w py-20 px-30">
      <el-row class="">
        <div class="float-l"></div>
        <!-- 设置显示字段 -->
        <el-dropdown
          trigger="click"
          class="float-r"
          v-if="xszdBtn && xszdBtn.isShow == '1'"
          :size="xszdBtn ? xszdBtn.componentSize : ''"
        >
          <el-button
            type="primary"
            :size="xszdBtn ? xszdBtn.componentSize : ''"
          >
            {{ xszdBtn ? xszdBtn.componentTiltle[$i18n.locale] : "" }}
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <template v-for="(item, index) in tableColumns">
                <el-dropdown-item :key="index" v-if="item.columnKey != 'xzk'">
                  <el-checkbox
                    v-model="show[index]"
                    :label="item.chinese"
                    @change="changeShow(show[index], index)"
                  ></el-checkbox>
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-row>
      <el-row class="mt-20">
        <!-- 动态表格组件 -->
        <TableCommon
          v-loading="tabLoading"
          :element-loading-text="$t('elTable.loadingText')"
          element-loading-spinner="el-icon-loading"
          :tableColumns="tableColumns"
          :tableData="tableData"
          :rowkey="'xzk'"
          :uniqueNum="uniqueNum"
          :cellStyle="$store.state.cellStyle"
          :headerCellStyle="$store.state.headerCellStyle"
          :height="$store.state.screenHeight - 285"
        ></TableCommon>
      </el-row>
      <el-row>
        <!-- 分页组件 -->
        <Pagination
          :currentPage="currentPage"
          :total="total"
          :limit="limit"
          :small="true"
          :pageSizes="$store.state.pageSizes"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
          :uniqueNum="uniqueNum"
        />
      </el-row>
    </el-row>
  </div>
</template>

<script>
import * as yhxx from "@/api/yhxx";
import * as sqgl from "@/api/sqgl";
import XmsqryDialog from "@/components/Dialog_xmsq_ry.vue";

export default {
  // 被授权信息一览
  name: "projectAuzBsqrView",
  components: {
    XmsqryDialog,
  },
  computed: {},
  data() {
    return {
      tabLoading: true,
      currentPage: 1,
      limit: this.$store.state.dataDisplayNum,
      total: 0, // 数据量
      tableColumns: [],
      tableData: [],
      uniqueNum: "Y120106-1-1", // 页面唯一标识（用于区分同一页面多个模块多个分组情况）
      yhxx: this.$store.state.yhxx.yhxx,
      bsqr: "",
      flg: "0",
      saveflg: "0",
      ryxx: null,
      ryxxData: [],
      rydm: null,
      dialogbsqr: false,
      multipleChoice: [],
      checkList: [],
      show: [],
      argumentDetail: {},
      argumentConfig: {
        xszdTil: {
          moduleId: "1",
          groupId: "1",
          fieldId: "btn-szxszd",
        },
      },
      xszdBtn: {},
    };
  },
  methods: {
    //   获取当前用户授权项目
    getBsqInfo() {
      let params = {};
      params.yhbh = this.yhxx.ygbh;
      params.currentPage = this.currentPage;
      params.limit = this.limit;
      // params.type = "xmsq";
      params.type = "";
      // sqgl.getBsqInfo(params).then((res) => {
      //   this.tabLoading = false;
      //   this.tableData = res.data.data;
      //   if (this.tableData.length > 0) {
      //     this.total = this.tableData[0].count;
      //   }
      // });
      sqgl.getBsqlogInfo(params).then((res) => {
        this.tabLoading = false;
        this.tableData = res.data.data.data;
        if (this.tableData.length > 0) {
          this.total = this.tableData[0].count;
        }
      });
      
    },
    /** 页码改变时会触发 */
    handleCurrentChange(uniqueNum, val) {
      this.currentPage = val;
      this.getBsqInfo();
    },
    /** 每页条数改变时触发 */
    handleSizeChange(uniqueNum, val) {
      this.currentPage = 1;
      this.limit = val;
      this.getBsqInfo();
    },
    /** 获取页面表格配置信息 */
    getPageTableConfig() {
      let params = {};
      params.pageId = "Y120106";
      params.moduleId = "1";
      params.groupId = "2";
      // 清空表格列配置
      this.tableColumns = []; // 表格列
      // 异步回调
      this.$requestUtil.getXtTableConfig(params).then((tmpResult) => {
        this.tableColumns = tmpResult;
        this.setShow(tmpResult);
      });
    },
    // 查询项目人员
    handleIconClick() {
      let arr = [];
      if (this.bsqr != null && this.bsqr != "") {
        yhxx.getSysUser({ rydm: this.bsqr }).then((res) => {
          let res1 = res.data.data;
          arr = res1.ryxx;
          this.saveflg = res1.flg;
          switch (res1.ryxx.length) {
            case 0:
              break;
            case 1:
              this.flg = res1.flg;
              this.ryxx = arr[0];
              if (this.flg == "1") {
                this.bsqr = arr[0].xm;
              } else {
                this.bsqr = arr[0].rydm;
              }
              this.rydm = arr[0].rydm;
              this.getBsqInfo();
              break;
            default:
              this.dialogbsqr = true;
              this.ryxxData = res1.ryxx;
              break;
          }
        });
      } else {
        this.flg = "0";
        this.rydm = null;
        this.getBsqInfo();
      }
    },
    // 获取查询条件信息
    loadQueryConfig() {
      let _this = this;
      let queryInfo = {
        pageId: "Y120106",
      };
      _this.$requestUtil.getXtQueryConfigMy(queryInfo).then((res) => {
        _this.argumentDetail = res;
        this.xszdBtn = this.getArgumentDetail("xszdTil");
      });
    },
    /** 获取参数详情 */
    getArgumentDetail(key) {
      return this.$requestUtil.getArgumentDetail(
        this.argumentConfig,
        this.argumentDetail,
        key
      );
    },

    changeShow(val, index) {
      if (val) {
        this.tableColumns[index].isShow = "1";
      } else {
        this.tableColumns[index].isShow = "0";
      }
    },
    setShow(tableColumns) {
      let columns = [];
      columns = tableColumns;
      columns.forEach((item) => {
        if (item.columnKey != "xzk") {
          if (item.isShow == "1") {
            this.show.push(true);
          } else {
            this.show.push(false);
          }
        }
      });
    },
  },
  mounted() {
    this.getBsqInfo();
    this.getPageTableConfig();
    this.loadQueryConfig();
  },
};
</script>

<style lang="scss"></style>
